import fetch from './fetch'

export default {
    getTraffickingScreeningsByPerson (payload) {
        let request = fetch({
            url: '/traffickingscreening',
            method: 'get',
            payload
        })
        return request.call()
    },

    createTraffickingScreening (payload) {
        let request = fetch({
            url: '/traffickingscreening',
            method: 'post',
            data: payload
        })

        return request.call()
    }
}

// import fetch from './fetch'

// export default {
//     getTraffickingScreenings (payload) {
//         const request = fetch({
//             url: '/traffickingscreening',
//             method: 'get',
//             payload
//         })
//         return request.call()
//     },

//     createTraffickingScreening (payload) {
//         const request = fetch({
//             url: '/traffickingscreening',
//             method: 'post',
//             data: payload
//         })

//         return request.call()
//     },

//     updateTraffickingScreening (payload, screeningId) {
//         const request = fetch({
//             url: `/traffickingscreening/${screeningId}`,
//             method: 'patch',
//             data: payload
//         })

//         return request.call()
//     },

//     downloadTraffickingScreening (payload) {
//         const request = fetch({
//             url: `/traffickingscreening/download/${payload._id}`,
//             method: 'get',
//             payload
//         })

//         return request.call()
//     }
// }



// WEBPACK FOOTER //
// ./src/api/traffickingScreening.js